import n, { useState as l, useMemo as f } from "react";
const M = n.createContext({});
function b({
  children: r,
  design: e
}) {
  const [o, t] = l(!1), [a, d] = l(null);
  function c(i) {
    d(i), t(!0);
  }
  function s() {
    t(!1);
  }
  const u = f(() => ({
    globalModal: a,
    isGlobalModalOpen: o,
    openModal: c,
    closeModal: s,
    design: e
  }), [a, o, e]);
  return /* @__PURE__ */ n.createElement(M.Provider, { value: u }, r);
}
export {
  M as SharedLandingCtx,
  b as SharedLandingProvider
};
//# sourceMappingURL=context.js.map
